import { headers } from './internal/headers';
export const add = (...opts) => {
    const httpHeaders = {};
    for (let i = opts.length; i--;) {
        const op = opts[i];
        op(httpHeaders);
    }
    return headers(httpHeaders);
};
